var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 11.6065C9.624 11.6065 9.31234 11.2948 9.31234 10.919V6.10648C9.31234 5.73064 9.624 5.41898 9.99984 5.41898C10.3757 5.41898 10.6873 5.73064 10.6873 6.10648V10.919C10.6873 11.2948 10.3757 11.6065 9.99984 11.6065Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 14.8148C9.75234 14.8148 9.52315 14.7231 9.34898 14.549C9.26648 14.4573 9.20234 14.3565 9.14734 14.2465C9.10151 14.1365 9.08317 14.0173 9.08317 13.8981C9.08317 13.6598 9.18398 13.4214 9.34898 13.2473C9.68815 12.9081 10.3115 12.9081 10.6507 13.2473C10.8157 13.4214 10.9165 13.6598 10.9165 13.8981C10.9165 14.0173 10.889 14.1365 10.8432 14.2465C10.7973 14.3565 10.7332 14.4573 10.6507 14.549C10.4765 14.7231 10.2473 14.8148 9.99984 14.8148Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21249 19.3798C8.7625 19.7006 9.38584 19.8565 10 19.8565C10.6142 19.8565 11.2375 19.7006 11.7875 19.3798L17.2325 16.2356C18.3325 15.5939 19.02 14.4114 19.02 13.1373V6.8673C19.02 5.59314 18.3325 4.41063 17.2325 3.76896L11.7875 0.624805C10.6784 -0.016862 9.31249 -0.016862 8.21249 0.624805L2.76749 3.76896C1.66749 4.41063 0.97998 5.59314 0.97998 6.8673V13.1373C0.97998 14.4114 1.66749 15.5939 2.76749 16.2356L8.21249 19.3798ZM8.89999 1.81646C9.23916 1.62396 9.62417 1.52312 10 1.52312C10.3758 1.52312 10.7608 1.62396 11.0908 1.81646L16.5358 4.96062C17.2142 5.35479 17.6359 6.08814 17.6359 6.8673V13.1373C17.6359 13.9256 17.2142 14.6498 16.5358 15.044L11.0908 18.1881C10.4217 18.5823 9.57833 18.5823 8.89999 18.1881L3.45499 15.044C2.77666 14.6498 2.35498 13.9164 2.35498 13.1373V6.8673C2.35498 6.07897 2.77666 5.35479 3.45499 4.96062L8.89999 1.81646Z",
    fill: "#D32F2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning2);
export default __webpack_public_path__ + "static/media/warning-2.5709416f8bd7a769f9d48673a5df028d.svg";
export { ForwardRef as ReactComponent };